import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypePostExchangeOrdersParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [교환 신청/등록] 교환 신청 등록 api 요청 훅
 */
const usePostExchangeOrders = () => {
  const { runAsync } = useAsyncHandler();

  const postExchangeOrders = useAPI<TypePostExchangeOrdersParams>({
    endpoint: API_ENDPOINT.CLAIM.POST_EXCHANGE_ORDERS,
    method: 'post',
  });

  const registerExchangeOrders = async (
    {
      params,
      pathParams: { outboundOrderCode },
    }: {
      params: TypePostExchangeOrdersParams;
      pathParams: { outboundOrderCode: string };
    },
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postExchangeOrders({ params, pathParams: `?outboundOrderCode=${outboundOrderCode}` }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { registerExchangeOrders };
};

export default usePostExchangeOrders;
